import { goApi } from './apiService';

export async function getLanguages() {
    const response = await goApi.get(`/tests-series/languages`);
    return response?.data;
}

export async function getTestDetails(testId: string) {
    const response = await goApi.get(`/tests/${testId}`);
    return response?.data;
}
